import type { IconData } from '@stacksjs/iconify-core'

export const otherUiLocationOff: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m0 1l1-1l2.05 2.05A7 7 0 0 1 15 7c0 1.938-.87 3.629-1.996 5.004L16 15l-1 1zm8 4c-.552 0-1.052.224-1.414.586l2.828 2.828A2 2 0 0 0 8 5\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M1.47 4.47A7 7 0 0 0 1 7c0 5.5 7 9 7 9s1.429-.714 2.995-2.005z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiLocationOff
